import { useSelector } from 'react-redux';
import { useParams } from 'quartz-routing/react-router';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { useRelevantCollections } from 'marketplace-ui-common/collections/hooks/useRelevantCollections';
import { useThemeCollectionItems } from '../../hooks/useThemeCollectionItems';
import AssetStorefrontContainer from '../../storefront/containers/AssetStorefrontContainer';
import NotFoundError from '../../components/error/NotFoundError';
import { getIsInApp } from '../../selectors/app';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ThemeCollectionContainer() {
  var _collection$title;
  const {
    collection: slug
  } = useParams();
  const isInApp = useSelector(getIsInApp);
  const appContext = isInApp ? 'app' : 'public';
  const {
    getCollectionBySlug,
    error,
    loading
  } = useRelevantCollections({
    appContext,
    offeringType: 'THEME'
  });
  const collection = getCollectionBySlug(slug);
  const {
    fetchThemeCollectionItemIds
  } = useThemeCollectionItems({
    appContext,
    collectionId: collection ? collection.id : undefined
  });
  if (loading || error) {
    return null;
  }
  if (!collection) {
    return /*#__PURE__*/_jsx(NotFoundError, {});
  }
  return /*#__PURE__*/_jsx(AssetStorefrontContainer, {
    collectionId: collection.id,
    title: (_collection$title = collection.title) !== null && _collection$title !== void 0 ? _collection$title : collection.name,
    description: /*#__PURE__*/_jsx(SanitizedText, {
      body: collection.description,
      WrapperComponent: "span"
    }),
    onFetchCollectionOfferingIds: fetchThemeCollectionItemIds
  });
}